import { AnchorLink } from "@hub/ui/anchor-link";
import React from "react";
import styles from "./cta-banner.module.css";

export enum CtaTheme {
  BLACK = "black",
  INDIGO = "indigo",
  ORANGE = "orange",
  EMERALD = "emerald",
  PURPLE = "purple",
}

interface CtaAction {
  label: string;
  url: string;
}

export interface CtaBannerProps {
  primaryAction: CtaAction;
  title: string;
  description: string | string[];

  theme?: CtaTheme;
  secondaryAction?: CtaAction;
}

export const CtaBanner: React.FC<CtaBannerProps> = ({
  primaryAction,
  secondaryAction,
  title,
  description,
  theme = CtaTheme.BLACK,
}) => {
  description = Array.isArray(description) ? description : [description];

  return (
    <>
      <div className={`${styles.ctaBanner} ${styles[theme]}`}>
        <div className={styles.headline}>
          <span className={styles.headline__title}>{title}</span>
          <div className={styles.headline__description}>
            {description.map((line: string, index) =>
              index === 0 ? (
                <span className={styles.headline__descriptionLine} key={index}>
                  {line}
                </span>
              ) : (
                <span
                  className={styles.headline__descriptionLine}
                  key={index}
                >{` ${line}`}</span>
              )
            )}
          </div>
        </div>
        <div className={styles.actions}>
          <AnchorLink
            to={primaryAction.url}
            openNewTab={true}
            options={{ button: true }}
            className={`${styles.action} ${styles.primaryAction}`}
          >
            {primaryAction.label}
            <div className={styles.action__arrow}>→</div>
          </AnchorLink>
          {secondaryAction && (
            <AnchorLink
              to={secondaryAction.url}
              openNewTab={true}
              options={{ button: true }}
              className={`${styles.action} ${styles.secondaryAction}`}
            >
              {secondaryAction.label}
              <div className={styles.action__arrow}>→</div>
            </AnchorLink>
          )}
        </div>
      </div>
    </>
  );
};
